export default "__VITE_ASSET__3b825f0b__"